module.exports = __webpack_public_path__ + "img/quest_icon_0024_health.b6b9b2e6.png";